import { clsx, type ClassValue } from "clsx"

// import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  // return twMerge(clsx(inputs)) // Aggiungere twMerge in caso le cose si mettono male :D
  return clsx(inputs)
}
